import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EditorMode } from '../../../../../../modules/editor/models/EditorModes';
import { useLoader } from '../../../../../helpers/useLoader';
import { IClarificationsStore } from '../Clarifications.store';
import { RequestClarificationModal } from '../components/RequestClarificationModal';
import { IClarificationsBl } from '../services/Clarifications.bl';

interface IProps {
  showModal: boolean;
  editorMode: EditorMode;
  onToggle: () => void;
}

export const RequestClarificationModalContainer = observer((props: IProps): ReactElement => {
  const clarificationStore = useInjection(IClarificationsStore.$);
  const clarificationsBl = useInjection(IClarificationsBl.$);

  const { withLoaderAsync } = useLoader();

  const getRequestClarificationCall = (): (() => Promise<void>) => {
    switch (props.editorMode) {
      case EditorMode.BATCH_ANNOTATION:
        return async () => {
          await clarificationsBl.batchRequestClarificationDuringAnnotationAsync();
        };
      case EditorMode.BATCH_REVIEW:
        return async () => {
          await clarificationsBl.batchRequestClarificationDuringReviewAsync();
        };
      case EditorMode.BATCH_REVIEWEDIT:
        return async () => {
          await clarificationsBl.batchRequestClarificationDuringReviewEditAsync();
        };
      case EditorMode.FREEACCESS_ANNOTATION:
        return async () => {
          await clarificationsBl.freeAccessRequestClarificationDuringAnnotationAsync();
        };
      case EditorMode.FREEACCESS_REVIEW:
        return async () => {
          await clarificationsBl.freeAccessRequestClarificationDuringReviewAsync();
        };
      case EditorMode.FREEACCESS_REVIEWEDIT:
        return async () => {
          await clarificationsBl.freeAccessRequestClarificationDuringReviewEditAsync();
        };
      case EditorMode.FREEACCESS_EDIT:
        return async () => {
          await clarificationsBl.freeAccessRequestClarificationDuringEditAsync();
        };
      default:
        return async () => Promise.resolve(undefined);
    }
  };

  const handleSaveClarification = async (): Promise<void> => {
    await withLoaderAsync(getRequestClarificationCall(), 'request-clarification-button');
    props.onToggle();
  };

  const handleQuestionChange = (value: string): void => {
    clarificationsBl.setClarificationQuestion(value);
  };

  return (
    <RequestClarificationModal
      showModal={props.showModal}
      question={clarificationStore.question}
      onToggleChange={props.onToggle}
      onQuestionChange={handleQuestionChange}
      onSaveClarification={handleSaveClarification}
    />
  );
});
